export * from './paths';

export const SupportedCountries = [
  'ch',
  'de',
  'at',
  'li',
  'fr',
  'it',
  'be',
  'bg',
  'dk',
  'ee',
  'fi',
  'gr',
  'ie',
  'hr',
  'lv',
  'lt',
  'lu',
  'mt',
  'nl',
  'pl',
  'pt',
  'ro',
  'se',
  'sk',
  'si',
  'es',
  'cz',
  'hu',
  'cy',
  'ua',
] as const;
